import React from 'react';
import { colors, typography } from "../../styles/theme";
import { buttons, surfaces } from "../../styles/components";

export default function EmptyState({ 
  icon = "📭", 
  title, 
  description, 
  actionLabel, 
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
  children 
}) {
  // Legacy support: if children provided, render simple version
  if (children) {
    return (
      <div
        style={{
          ...surfaces.card,
          textAlign: "center",
          color: colors.textMuted,
        }}
      >
        {children}
      </div>
    );
  }

  // New enhanced empty state
  return (
    <div style={styles.container}>
      <div style={styles.iconContainer}>
        <span style={styles.icon}>{icon}</span>
      </div>
      <h3 style={styles.title}>{title}</h3>
      <p style={styles.description}>{description}</p>
      
      {(actionLabel || secondaryActionLabel) && (
        <div style={styles.actions}>
          {actionLabel && onAction && (
            <button onClick={onAction} style={styles.primaryButton}>
              {actionLabel}
            </button>
          )}
          {secondaryActionLabel && onSecondaryAction && (
            <button onClick={onSecondaryAction} style={styles.secondaryButton}>
              {secondaryActionLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px',
    textAlign: 'center',
    backgroundColor: colors.bgSoft,
    borderRadius: '12px',
    margin: '20px 0',
  },
  iconContainer: {
    marginBottom: '20px',
  },
  icon: {
    fontSize: '64px',
    opacity: 0.8,
  },
  title: {
    ...typography.h3,
    color: colors.textDark,
    marginBottom: '8px',
  },
  description: {
    ...typography.body,
    color: colors.textMuted,
    maxWidth: '400px',
    marginBottom: '24px',
    lineHeight: '1.6',
  },
  actions: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  primaryButton: {
    ...buttons.primary,
    padding: '12px 24px',
    fontSize: '16px',
    border: 'none',
    cursor: 'pointer',
  },
  secondaryButton: {
    ...buttons.secondary,
    padding: '12px 24px',
    fontSize: '16px',
    cursor: 'pointer',
  },
};

